export default "__VITE_ASSET__9357e2de__"